import { createFileRoute, Outlet } from "@tanstack/react-router"
import { AnimatePresence } from "motion/react"
import { useEffect, useState } from "react"

import { cn } from "@repo/ui/lib/utils"
import { GlobalSearch } from "./_components/global-search"
import { Header } from "./_components/header"
import { Navigation } from "./_components/navigation"

export const Route = createFileRoute("/_protected-layout/_os-layout")({
  component: RouteComponent,
})

function RouteComponent() {
  const [showSearch, setShowSearch] = useState(false)
  const [background, setBackground] = useState<string>(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("os-background") || "/os-bg-1.jpg"
    }
    return "/os-bg-1.jpg"
  })
  const [bgType, setBgType] = useState<"light-bg" | "dark-bg">("dark-bg")

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("os-background", background)
    }

    // Determine if the background is light or dark
    if (background.startsWith("#")) {
      // For color backgrounds, check the brightness
      const hex = background.replace("#", "")
      const r = Number.parseInt(hex.substr(0, 2), 16)
      const g = Number.parseInt(hex.substr(2, 2), 16)
      const b = Number.parseInt(hex.substr(4, 2), 16)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      setBgType(brightness > 128 ? "light-bg" : "dark-bg")
    } else {
      // For image backgrounds, default to dark
      setBgType("dark-bg")
    }
  }, [background])

  // TODO: Replace this stuff with the `useHotkeys` hook (https://www.npmjs.com/package/react-hotkeys-hook)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Command+Space or Windows+Space
      if ((e.metaKey || e.ctrlKey) && e.code === "Space") {
        e.preventDefault()
        setShowSearch((prev) => !prev)
      }
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [])

  return (
    <div
      className={cn("flex min-h-screen flex-col", bgType)}
      style={{
        ...(background.startsWith("#")
          ? { backgroundColor: background }
          : {
              backgroundImage: `url(${background})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }),
      }}
    >
      <Header onBgChange={setBackground} />

      <main className="flex flex-1 flex-col overflow-hidden px-2 pb-20 md:pb-0">
        <div className="flex-1 overflow-auto">
          <AnimatePresence mode="wait">
            <Outlet />
          </AnimatePresence>
        </div>
      </main>

      <Navigation />

      <GlobalSearch isOpen={showSearch} onClose={() => setShowSearch(false)} />
    </div>
  )
}
